import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import { traerConfiguracionBackend } from '../Utils/BackendUnificado';

//material-ui
import MomentUtils from '@date-io/moment';
import "moment/locale/es";
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import { valInputText, onPasteText, onPasteNum, valInputNum, valEmailText } from '../../../utils/validate.js'
import Snackbar from '@material-ui/core/Snackbar';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import SvgIcon from '@material-ui/core/SvgIcon';


// Components
import Header from './Header';
import SnackbarContentWrapper from './../../Global/SnackbarContentWrapper';
import ValidatedDatePicker from './../../Global/ValidatedDatePicker';

// persistencia en redux
import { 
    setPlazoFijoPrimerFormulario 
} from '../../../actions/actions';

import { connect } from 'react-redux';

class DatosBasicos extends Component {
    constructor(props) {
        moment.locale('esp');
        super(props);
        this.state = {
            nombre: "",
            apellido: "",
            dni: '',
            errorDni : false,
            ejemplar: "",//TODO
            idTributario: "",
            tipo: "",//TODO
            genero: "",//TODO
            email: "",
            telefonoMovil: "",
            generos: {},
            tipoTributarios: [],
            versionDocumentos: [],
            open: false,
            fechaNacimiento: null,
            fechaNacimientoFormat: moment().add(-18, 'year').format("DD/MM/YYYY"),
            locale: 'es',
            isErrorInDate: false,
            customErrorMessage: ""
        }
        this.handleChange = this.handleChange.bind(this);
        this.datosBasicos = this.datosBasicos.bind(this);
        this.handleKeyPressText = this.handleKeyPressText.bind(this);
        this.handlePasteText = this.handlePasteText.bind(this);
        this.snackbar = this.snackbar.bind(this);
        this.isDataValid = this.isDataValid.bind(this);
    }

    componentWillMount() { 
        traerConfiguracionBackend(true, false)
            .then(res => this.inicializarDatosBasicos())
            .catch(err => this.inicializarDatosBasicos());
    }

    componentDidMount() {
        
    }

    handleKeyPressText = event => {
        if (!valInputText(event)) {
            event.preventDefault();
        }
    }

    handlePasteText = event => {
        onPasteText(event)
    }

    handleKeyPressNum = event => {
        if (!valInputNum(event)) {
            event.preventDefault();
        }
    }

    handlePasteNum = event => {
        onPasteNum(event)
    }

    snackbar = () => {
        this.setState({ open: true });
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    };

    inicializarDatosBasicos() {
        axios.get(localStorage.getItem('url') + '/api/plazoFijo/inicializarDatosBasicos',{withCredentials: true}).then(response => {
            if (response.status === 200) {
                this.setState({
                    generos: response.data.generos,
                    tipoTributarios: response.data.tipoTributarios,
                    versionDocumentos: response.data.versionDocumentos
                });

                this.props.setPlazoFijoPrimerFormulario({
                    ejemplar: response.data.versionDocumentos[0].id,
                    tipo: response.data.tipoTributarios[0].id,
                })

            }else{
                this.props.history.push('/plazo-fijo/PF-fail');                
            }
        }).catch(error => {
            //TODO
            this.props.history.push('/plazo-fijo/PF-fail');
        });
    }

    handleChange = event => {
        let value = event.target.value
        let name = event.target.name

        if (this.props.plazoFijoPrimerFormulario.apellido !== "" && event.target.name === 'dni' && (event.target.value.length == 7 || event.target.value.length == 8)) {
            axios.get(localStorage.getItem('url') + '/api/plazoFijo/obtenerCuil?dni=' + event.target.value + '&apYNom=' + this.state.apellido,{withCredentials: true}).then((response) => {

                if( response.status === 200 ){
                    let errorDni = ( response.data.toString().length == 0 )?true:false
                    let idTributario = ( response.data.toString().length == 0 )?"":response.data.toString()

                    this.props.setPlazoFijoPrimerFormulario({
                        "idTributario" : idTributario
                    })    

                    this.setState({
                        errorDni
                    });
                }else{
                    this.props.history.push('/plazo-fijo/PF-fail');    
                }

            }).catch((err) => {
                this.props.history.push('/plazo-fijo/PF-fail');
            });
        }

        if( !this.isDataValid(name,value) ){
            return
        }

        let data = {}
        data[name] = value
        
        this.props.setPlazoFijoPrimerFormulario(data)    
    }

    isDataValid(name,value){
        let ok = true
        
        if( (name === "nombre" && value.length > 64) ||
            (name === "apellido" && value.length > 32) ||
            (name === "dni" && value.length > 8) || 
            (name === "idTributario" && value.length > 11) || 
            (name === "telefonoMovil" && value.length > 10) ){
            ok = false
        }
        return ok
    }

    handleDateChange = (fechaNacimiento, isEmpty) => {
        let validFormat;
        let isTooYoung;
        let isInvalidDate;
        let errorMessage = "";
        let fechaNacimientoEntered;
        let isErrorDateEntered;
        let isTooOld;

        if (!isEmpty) {
            validFormat = moment(fechaNacimiento, 'DD/MM/YYYY', true).isValid();
            if (validFormat) isTooYoung = fechaNacimiento.isAfter(moment().add(-18, 'year'));
            if (validFormat) isInvalidDate = fechaNacimiento.isAfter(moment());
            if (validFormat) isTooOld = fechaNacimiento.isBefore(moment().add(-100, 'year'));

            switch (true) {
                case (!validFormat || isInvalidDate):
                    isErrorDateEntered = true;
                    if (!validFormat) {
                        fechaNacimientoEntered = null;
                        errorMessage = "Formato de fecha incorrecto";
                    } else {
                        fechaNacimientoEntered = fechaNacimiento;
                        errorMessage = "Ingresá una fecha válida";
                    }
                    break;
                case (isTooYoung):
                    errorMessage = "Tenés que ser mayor de 18 años";
                    fechaNacimientoEntered = fechaNacimiento;
                    isErrorDateEntered = true;
                    break;
                case (isTooOld):
                    errorMessage = "Fecha fuera de rango";
                    fechaNacimientoEntered = fechaNacimiento;
                    isErrorDateEntered = true;
                    break;
                default:
                    isErrorDateEntered = false;
                    fechaNacimientoEntered = fechaNacimiento;
                    break;
            }
        } else {
            isErrorDateEntered = true;
            fechaNacimientoEntered = null;
            errorMessage = "Fecha de nacimiento requerido";
        }

        this.setState({
            isErrorInDate: isErrorDateEntered,
            fechaNacimiento: fechaNacimientoEntered,
            fechaNacimientoFormat: fechaNacimiento != undefined ? fechaNacimiento.format("DD/MM/YYYY") : null,
            customErrorMessage: errorMessage
        });
    };

    checkAge = e => {
        let isEmpty = e.target.value == "" ? true : false;
        let dateValue;
        if (!isEmpty) dateValue = moment(e.target.value, "DD/MM/YYYY")
        this.handleDateChange(dateValue, isEmpty);
    }

    datosBasicos = (event) => {
        if (!this.state.isErrorInDate) {

            event.preventDefault();
            $(".load").fadeIn(700);

            const {  plazoFijoPrimerFormulario } = this.props;

            let data = {
                nombre: plazoFijoPrimerFormulario.nombre,
                apellido: plazoFijoPrimerFormulario.apellido,
                dni: plazoFijoPrimerFormulario.dni,
                ejemplar: plazoFijoPrimerFormulario.ejemplar,
                idTributario: plazoFijoPrimerFormulario.idTributario,
                tipo: plazoFijoPrimerFormulario.tipo,
                genero: plazoFijoPrimerFormulario.genero,
                email: plazoFijoPrimerFormulario.email,
                telefonoMovil: plazoFijoPrimerFormulario.telefonoMovil,
                fechaNacimiento: plazoFijoPrimerFormulario.fechaNacimientoFormat
            }
            axios({
                method: 'post',
                timeout: 60 * 4 * 1000,
                data,
                url: localStorage.getItem('url') + '/api/plazoFijo/iniciar'
            },{withCredentials: true}).then((response) => {
                $(".load").fadeOut(700);

                if (response.data.codigo == "SUCCESS") {
                    this.props.history.push('/plazo-fijo/PF-info-personal');

                }else if (response.data.codigo == "PR") {
                    this.props.history.push('/plazo-fijo/PF-cliente-existente');
                    
                }else { //puede ser IN(Terrorista) o SCORING 
                    this.props.history.push('/plazo-fijo/PF-solicitud-no-procesada');
                } 
            }).catch(error => {
                $(".load").fadeOut(700);
                this.props.history.push('/plazo-fijo/PF-fail');
            });
        }else{
            this.snackbar();
        }
    }

    render() {
        const { classes, plazoFijoPrimerFormulario } = this.props;
        const tipoTributarios = this.state.tipoTributarios;
        const generos = this.state.generos;
        const versionDocumentos = this.state.versionDocumentos;
        const { errorDni } = this.state;
        
        let helperTextDni = null
        if(errorDni){
            helperTextDni = "dni invalido"
        }

        return (
            <div className="datos-basicos">
                <Header />
                <div className="datos-basicos-container">
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} md={9} >
                            <ValidatorForm
                                ref="form-datos-basicos"
                                onSubmit={this.datosBasicos}
                                onError={errors => this.snackbar()}
                            >
                                <Grid container spacing={8}>
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                            <g fill="none">
                                                <path d="M-4-4h24v24H-4z" />
                                                <path fill="#B2B2B2" d="M8 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={5} >
                                        <TextValidator
                                            validators={['required', 'isString', 'maxStringLength:64', 'minStringLength:1']}
                                            errorMessages={['Nombre es requerido', 'Caracter válido', "Maximo 64 caracteres"]}
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoPrimerFormulario.nombre}
                                            id="nombre"
                                            label="Nombre"
                                            name="nombre"
                                            type="text"
                                            onKeyPress={this.handleKeyPressText}
                                            onPaste={this.handlePasteTex}
                                        />
                                    </Grid>
                                    <Grid item xs={11} md={5} className={classes.marginGrid}>
                                        <TextValidator
                                            validators={['required', 'isString', 'maxStringLength:64', 'minStringLength:1']}
                                            errorMessages={['Apellido es requerido', 'Caracter inválido', "Maximo 64 caracteres"]}
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoPrimerFormulario.apellido}
                                            id="apellido"
                                            label="Apellido"
                                            name="apellido"
                                            onKeyPress={this.handleKeyPressText}
                                            onPaste={this.handlePasteTex}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8} >
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
                                            <g fill="none">
                                                <path d="M-2-5h24v24H-2z" />
                                                <path fill="#B2B2B2" d="M18.333 0C19.208 0 20 .792 20 1.667v11.666c0 .875-.792 1.667-1.667 1.667H1.667C.792 15 0 14.208 0 13.333V1.667C0 .792.792 0 1.667 0h16.666zm-6.666 3.333h6.666V2.5h-6.666v.833zm0 1.667h6.666v-.833h-6.666V5zm0 1.667H17.5v-.834h-5.833v.834zm-10 5v.833h10v-.833c0-1.667-3.334-2.575-5-2.575-1.667 0-5 .908-5 2.575zm5-9.167a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z" />
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={5} >
                                        <TextValidator
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoPrimerFormulario.dni}
                                            id="dni"
                                            label="DNI"
                                            name="dni"
                                            
                                            validators={['required', 'isNumber', 'maxStringLength:8', 'minStringLength:7']}
                                            errorMessages={['DNI requerido', 'DNI inválido', "Maximo 8 caracteres", "Minimo 7 caracteres"]}
                                            error={errorDni}
                                            helperText={helperTextDni}
                                            onKeyPress={this.handleKeyPressNum}
                                        />
                                    </Grid>
                                    <Grid item xs={11} md={5} className={classes.marginGrid}>
                                        <FormControl className="datos-basicos-form-control">
                                            <InputLabel htmlFor="age-simple">Ejemplar</InputLabel>
                                            <Select
                                                onChange={this.handleChange}
                                                validators={['required']}
                                                value={plazoFijoPrimerFormulario.ejemplar}
                                                inputProps={{
                                                    name: 'ejemplar',
                                                    id: 'ejemplar',
                                                    name: 'ejemplar'
                                                }}
                                            >
                                                {Array.isArray(versionDocumentos) ?
                                                    versionDocumentos.map((versionDocumento, key) => (
                                                        <MenuItem key={key} value={versionDocumento.id}>
                                                            {versionDocumento.descripcion}
                                                        </MenuItem>
                                                    )) : null
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8}>
                                    <Grid item xs={1} className={classes.svgCenter}>

                                        <svg width="20px" height="20px" viewBox="0 0 20 20">
                                            <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                <g id="MOVIL_FLUJO_1" transform="translate(-20.000000, -619.000000)" fill="#B2B2B2">
                                                    <path d="M21,623 C20.45,623 20,623.45 20,624 L20,637 C20,638.1 20.9,639 22,639 L35,639 C35.55,639 36,638.55 36,638 C36,637.45 35.55,637 35,637 L23,637 C22.45,637 22,636.55 22,636 L22,624 C22,623.45 21.55,623 21,623 Z M38,619 L26,619 C24.9,619 24,619.9 24,621 L24,633 C24,634.1 24.9,635 26,635 L38,635 C39.1,635 40,634.1 40,633 L40,621 C40,619.9 39.1,619 38,619 Z M36,628 L28,628 C27.45,628 27,627.55 27,627 C27,626.45 27.45,626 28,626 L36,626 C36.55,626 37,626.45 37,627 C37,627.55 36.55,628 36,628 Z M32,632 L28,632 C27.45,632 27,631.55 27,631 C27,630.45 27.45,630 28,630 L32,630 C32.55,630 33,630.45 33,631 C33,631.55 32.55,632 32,632 Z M36,624 L28,624 C27.45,624 27,623.55 27,623 C27,622.45 27.45,622 28,622 L36,622 C36.55,622 37,622.45 37,623 C37,623.55 36.55,624 36,624 Z" id="Shape"></path>
                                                </g>
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={5} >
                                        <TextValidator
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoPrimerFormulario.idTributario}
                                            id="idTributario"
                                            label="CUIL/CUIT"
                                            name="idTributario"
                                            validators={['required', 'isNumber', 'maxStringLength:11', 'minStringLength:11']}
                                            errorMessages={['CUIL/CUIT requerido', 'CUIL/CUIT inválido', "Maximo 11 caracteres", "Mínimo 11 caracteres"]}
                                            onKeyPress={this.handleKeyPressNum}

                                        />
                                    </Grid>
                                    <Grid item xs={11} md={5} className={classes.marginGrid}>
                                        <FormControl className="datos-basicos-form-control">
                                            <InputLabel htmlFor="age-simple">Tipo</InputLabel>
                                            <Select onChange={this.handleChange}
                                                value={plazoFijoPrimerFormulario.tipo}
                                                inputProps={{
                                                    name: 'tipo',
                                                    id: 'tipo'
                                                }}>
                                                {
                                                    Array.isArray(tipoTributarios) ?
                                                        tipoTributarios.map((tipoTributario, key) => (
                                                            <MenuItem key={key} value={tipoTributario.id}>
                                                                {tipoTributario.descripcion}
                                                            </MenuItem>
                                                        )) : null
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8}>
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
                                            <g fill="none">
                                                <path d="M-3.99-2h24v24h-24z" />
                                                <path fill="#B2B2B2" d="M1.5 19v-6.5H1c-.55 0-1-.45-1-1V7c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v4.5c0 .55-.45 1-1 1h-.5V19c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1zM14 19v-5h1.61c.68 0 1.16-.67.95-1.32l-2.1-6.31A2.01 2.01 0 0 0 12.56 5h-.12a2 2 0 0 0-1.9 1.37l-2.1 6.31c-.22.65.26 1.32.95 1.32H11v5c0 .55.45 1 1 1h1c.55 0 1-.45 1-1zM3.5 4c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2zm9 0c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2z" />
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={5}>
                                        <FormControl className="datos-basicos-form-control">
                                            <SelectValidator
                                                label="Género"
                                                validators={['required']}
                                                errorMessages={['Género requerido']}
                                                onChange={this.handleChange}
                                                value={plazoFijoPrimerFormulario.genero}
                                                inputProps={{
                                                    name: 'genero',
                                                    id: 'genero',
                                                    name: 'genero'
                                                }}
                                            >
                                                {Array.isArray(Object.keys(generos)) ?
                                                    Object.keys(generos).map((genero, key) => (
                                                        <MenuItem key={key} value={genero}>
                                                            {generos[genero]}
                                                        </MenuItem>
                                                    )) : null
                                                }

                                            </SelectValidator>
                                        </FormControl>
                                    </Grid>
                                    <Grid item container alignItems="center" justify="flex-end" direction="row" xs={12} md={6}>

                                        <Grid item xs={1} >
                                            <svg width="20px" height="15px" viewBox="0 0 20 15">
                                                <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                    <g id="MOVIL_FLUJO_1" transform="translate(-20.000000, -836.000000)" fill="#B2B2B2">
                                                        <g id="CLAVE" transform="translate(9.000000, 809.000000)">
                                                            <g id="black-envelope" transform="translate(11.000000, 27.000000)">
                                                                <path d="M1.57357143,0.950714286 L8.74071429,6.62785714 C9.06571429,6.885 9.51357143,6.99928571 9.94857143,6.97785714 C10.3828571,6.99928571 10.8307143,6.88571429 11.1557143,6.62785714 L18.3228571,0.950714286 C18.8971429,0.498571429 18.7671429,0.127857143 18.0385714,0.127857143 L9.94928571,0.127857143 L1.86,0.127857143 C1.13071429,0.127857143 1.00071429,0.498571429 1.57357143,0.950714286 Z" id="Path"></path>
                                                                <path d="M18.8407143,2.44857143 L11.0085714,8.395 C10.7157143,8.615 10.3321429,8.72214286 9.95,8.71714286 C9.56714286,8.72214286 9.18357143,8.61428571 8.89071429,8.395 L1.05714286,2.44857143 C0.475714286,2.00785714 0,2.24428571 0,2.97357143 L0,12.73 C0,13.4592857 0.597142857,14.0564286 1.32642857,14.0564286 L9.94857143,14.0564286 L18.5714286,14.0564286 C19.3007143,14.0564286 19.8978571,13.4592857 19.8978571,12.73 L19.8978571,2.97357143 C19.8978571,2.24428571 19.4221429,2.00785714 18.8407143,2.44857143 Z" id="Path"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>                                            
                                        </Grid>
                                        

                                        <Grid item xs={11} md={9}>
                                            <TextValidator
                                                fullWidth
                                                className="input-container"
                                                onChange={this.handleChange}
                                                value={plazoFijoPrimerFormulario.email}
                                                id="email"
                                                label="Correo Electrónico"
                                                name="email"
                                                type="email"
                                                validators={['required', 'isEmail', 'maxStringLength:64']}
                                                errorMessages={['Correo Electrónico requerido', 'Correo Electrónico inválido', "Maximo 64 caracteres"]}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8}>
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg width="12px" height="20px" viewBox="0 0 12 20">
                                            <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                <g id="MOVIL_FLUJO_1" transform="translate(-24.000000, -902.000000)" fill="#B2B2B2">
                                                    <g id="CLAVE-Copy" transform="translate(9.000000, 879.000000)">
                                                        <g id="cellphone" transform="translate(15.000000, 23.000000)">
                                                            <path d="M9.99368687,20 C9.99368687,20 11.8090657,20 11.8090657,18.1818939 L11.8090657,1.81810606 C11.8090657,0 9.99368687,0 9.99368687,0 L1.82449495,0 C1.82449495,0 0.00911616162,0 0.00911616162,1.81810606 L0.00911616162,18.1818939 C0.00911616162,20 1.82449495,20 1.82449495,20 L9.99368687,20 Z M5.90909091,19.2429798 C5.40805556,19.2429798 5.00141414,18.8363131 5.00141414,18.335303 C5.00141414,17.8342424 5.40805556,17.4276263 5.90909091,17.4276263 C6.41012626,17.4276263 6.81679293,17.8342677 6.81679293,18.335303 C6.81679293,18.8363384 6.41015152,19.2429798 5.90909091,19.2429798 Z M3.63987374,1.10828283 C3.63987374,0.995732323 3.72974747,0.907676768 3.8404798,0.907676768 L7.97684343,0.907676768 C8.08757576,0.907676768 8.17833333,0.997550505 8.17833333,1.10828283 L8.17833333,1.16184343 C8.17833333,1.27530303 8.0884596,1.36244949 7.97775253,1.36244949 L3.8404798,1.36244949 C3.73065657,1.36244949 3.63987374,1.27257576 3.63987374,1.16184343 L3.63987374,1.10828283 Z M0.916818182,2.26921717 L10.9013889,2.26921717 L10.9013889,16.7922222 L0.916818182,16.7922222 L0.916818182,2.26921717 Z" id="Shape"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </Grid>
                                    
                                    <Grid item xs={11} md={5} >
                                        <TextValidator
                                            fullWidth
                                            className="input-container"
                                            onChange={this.handleChange}
                                            value={plazoFijoPrimerFormulario.telefonoMovil}
                                            id="telefonoMovil"
                                            label="Teléfono"
                                            name="telefonoMovil"
                                            placeholder="Ej: 1123456789"
                                            validators={['required', 'isNumber', 'maxStringLength:10', 'minStringLength:10']}
                                            errorMessages={['Teléfono requerido', 'Teléfono inválido', "Maximo 10 digitos", "Minimo 10 digitos"]}
                                            onKeyPress={this.handleKeyPressNum}
                                            onPaste={this.handlePasteNum}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} container spacing={0} justify="center">
                                    <Button size="small" type="submit" name="action" variant="contained" color="primary" className={classes.btnbNoShadow + " btn"}>Continuar</Button>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                    </Grid>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={3000}
                    onClose={this.handleClose}
                >
                    <SnackbarContentWrapper
                        onClose={this.handleClose}
                        variant="error"
                        message="Revisá los campos en rojo."
                    />
                </Snackbar>
            </div>
        );
    }
}

const styles = {
    root: {
        flexGrow: 1,
    },
    marginGrid: {
        marginLeft: "8% !important"
    },
    svgCenter: {
        display: "block",
        marginTop: "25px !important",
        textAlign: "center"
    },
    svgCenterRight: {
        display: "block",
        marginBottom: "1% !important",
        textAlign: "center"
    },
    btnbNoShadow: {
        boxShadow: "0px 0px 0px 0px !important",
        '&:hover':{
            color: '#fff',
            backgroundColor: '#fa9c5f'
        }
    },
    '@media  screen and (max-width: 800px)': {
        svgCenterRight: {
            marginBottom: "4% !important"
        }
    }
};

const mapStateToProps = (state) => {
    return ({
        plazoFijoPrimerFormulario: state.plazoFijoPrimerFormulario,
        estadoLocal: 'PLAZO_FIJO_PRIMER_FORMULARIO'
    });
}

const mapDispatchToProps = {
    setPlazoFijoPrimerFormulario
}


export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(DatosBasicos));

//api/plazoFijo/obtenerCuil

///api/plazoFijo/iniciar


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosBasicos/DatosBasicos.js